import { tnoSecondaryDark, tnoSecondaryLight } from './tnoBrandColors';

const fuchsiaMain = '#D81B60';
const fuchsiaLight = '#F06292';
const fuchsiaDark = '#AD1457';

export const light = {
  alternate: {
    main: '#fdf2f7',
    dark: '#f8e1ec',
  },
  cardShadow: 'rgba(216, 27, 96, 0.12)',
  mode: 'light',
  primary: {
    main: fuchsiaMain,
    light: fuchsiaLight,
    dark: fuchsiaDark,
    contrastText: '#fff',
  },
  secondary: { ...tnoSecondaryLight },
  text: {
    primary: '#2d3748',
    secondary: '#646e73',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#1a2138',
    dark: '#151a30',
  },
  cardShadow: 'rgba(0, 0, 0, 0.11)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: fuchsiaLight,
    light: '#f48fb1',
    dark: fuchsiaMain,
    contrastText: '#fff',
  },
  secondary: { ...tnoSecondaryDark },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#222B45',
    default: '#222B45',
    level2: '#333',
    level1: '#2D3748',
  },
};
